module.exports = __webpack_public_path__ + "static/media/25.336b86fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/25.jpg
// module id = 186
// module chunks = 0